import { render, staticRenderFns } from "./BaseMitAppNavigation.vue?vue&type=template&id=58e52d3c&scoped=true"
import script from "./BaseMitAppNavigation.vue?vue&type=script&lang=js"
export * from "./BaseMitAppNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e52d3c",
  null
  
)

export default component.exports